import React, { useEffect, useRef } from "react";
import { useAuthContext } from "../context/AuthContext";
import { useTestContext } from "../context/TestContext";
import { IoIosSearch } from "../utils/Icons";
import { useNavigate } from "react-router-dom";
import { useBottomNavbarContext } from "../context/BottomNavBarContext";

const brandImages = [

  {
    link: "labs/redcliffe-labs",
    img: "https://finelabs-images.s3.ap-south-1.amazonaws.com/redcliffe-logo.svg"
  },
  {
    link: "labs/pathkind-labs",
    img: "https://finelabs-images.s3.ap-south-1.amazonaws.com/pathkind-logo.svg"
  },

  {
    link: "labs/metropolis-healthcare",
    img: "https://finelabs-images.s3.ap-south-1.amazonaws.com/metropolis-logo.svg"
  },
  {
    link: "labs/agilus-diagnostics",
    img: "https://finelabs-images.s3.ap-south-1.amazonaws.com/agilus-logo.svg"
  },
  {
    link: "labs/dr-lal-pathLabs",
    img: "https://finelabs-images.s3.ap-south-1.amazonaws.com/Dr+Lal+logo.svg"
  }
];

const Searchbar = () => {
  const { setIsSearchVisible, deviceOS } = useAuthContext();
  const {
    fetchGlobalSearch,
    searchQuery,
    setSearchQuery,
    handleGlobalSearchChange,
    globalSearchData,
    // handleSearchClick,
    //isDebounceDropdown,
    //setIsDebounceDropdown,
    globalSearchQuery,
    setGlobalSearchQuery,
    productsByBrandAndTypeAndQuery,
    setProductsBySearchQuery,
    productsBySearchQuery,
    fetchProductsBySearchQuery,
    productsToBeSearched,
    handleAddProductsToBeSearched,
    handleRemoveProductsToBeSearched
  } = useTestContext();


  const {
    setIsHomeActive,
    setIsTestsActive,
    setIsPackagesActive,
    setIsRadiologyActive,
    setIsProfileActive,
  } = useBottomNavbarContext();


  const divRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSearchVisible(!entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current);
      }
    };
  }, []);

  const handleSearchQueryChange = (e) => {
    setProductsBySearchQuery([]);
    setGlobalSearchQuery(e.target.value);
    if (e.target.value.length >= 3) {
      fetchProductsBySearchQuery(e.target.value)
    }
  };

  const handleSearchClick = async () => {
    if (productsToBeSearched.length >= 1) {
      setIsHomeActive(false);
      setIsTestsActive(false);
      setIsPackagesActive(false);
      setIsRadiologyActive(false);
      setIsProfileActive(false);
      const queryParam = productsToBeSearched.join('$');
      navigate(`/search?products=${encodeURIComponent(queryParam)}`);
    }
  }

  const scrollContainerRef = useRef(null);
  const phoneScrollContainerRef = useRef(null);

  // Add this useEffect to auto-scroll when products are added
  useEffect(() => {
    if (scrollContainerRef.current && productsToBeSearched.length > 0) {
      const scrollContainer = scrollContainerRef.current;
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  }, [productsToBeSearched]);

  useEffect(() => {
    if (phoneScrollContainerRef.current && productsToBeSearched.length > 0) {
      const phoneScrollContainer = phoneScrollContainerRef.current;
      phoneScrollContainer.scrollTop = phoneScrollContainer.scrollHeight;
    }
  }, [productsToBeSearched]);


  const searchBarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
        setGlobalSearchQuery("")
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/** Large Screens */}
      <div
        className="w-full h-fit bg-whiteColor hidden lg:flex lg:flex-col justify-center items-center px-[3%] pb-[2%] relative"
        ref={divRef}
      >
        <img
          src="/assets/finelabs-logo-light.svg"
          alt="finelabs-logo"
          className="w-[1%] absolute bottom-[17.5%] left-[1.5%]"
        />
        <div className="w-full h-fit bg-gradient-to-b from-[#2674E9] to-[#0E41A6] flex flex-col justify-end items-center rounded-3xl p-[3%]">
          <span className="font-semibold text-[2vw] text-whiteColor">
            Your Health, Our Expertise – Accurate Tests
          </span>
          <span className="font-semibold text-[2vw] text-whiteColor mb-[0.75%]">
            From Leading Brands
          </span>
          <p className="font-light text-[1vw] text-whiteColor">
            Unlock accurate, fast, and affordable lab tests and radiology
          </p>
          <p className="font-light text-[1vw] text-whiteColor mb-[1.5%]">
            packages from trusted, leading brands.
          </p>
          <div className="bg-whiteColor/75 flex justify-center items-center rounded-2xl p-[0.5%] space-x-2 mb-[2.5%]">
            {brandImages?.map((lab, index) => (
              <img
                src={lab.img}
                alt="brand-logo"
                key={index}
                loading="lazy"
                className="w-[72px] h-[72px] object-cover cursor-pointer rounded-xl"
                onClick={() => navigate(lab.link)}
              />
            ))}
          </div>
          <div ref={(deviceOS === "unknown") ? searchBarRef : null} className="w-[50%] h-[56px] bg-whiteColor flex justify-between items-center rounded-[48px]  relative">
            <div className="flex w-full flex items-center ml-[2%] overflow-y-scroll" >
              {productsToBeSearched.length == 0 && (<IoIosSearch className="text-xl text-blue-300 mr-[2%]" />)}
              {productsToBeSearched.length > 0 && (
                <div ref={scrollContainerRef} className={`w-fit h-12 gap-y-2 gap-x-2 ${productsToBeSearched.length == 1 ? 'grid grid-cols-1' : 'grid grid-cols-2'} pt-2  mr-2`}>
                  {productsToBeSearched.map((product, index) => (
                    <div key={index} className="w-full px-2 h-[28px] rounded-[28px] bg-[#E0E0E0] flex justify-between items-center mr-2 text-[13px] text-[#57636C]">
                      <div className="w-fit truncate">
                        {product}
                      </div>
                      <img
                        src="/assets/close-icon.svg"
                        alt="close-icon"
                        className="cursor-pointer ml-1 flex-shrink-0"
                        onClick={() => handleRemoveProductsToBeSearched(product)}
                      />
                    </div>
                  ))}
                </div>
              )}

              <input
                type="text"
                value={globalSearchQuery}
                onChange={handleSearchQueryChange}
                placeholder="Search from 12,000+ Lab Tests, Packages, X-rays & Scans"
                className={`${productsToBeSearched.length > 0 ? 'w-[50%]' : 'w-[92.5%]'} h-full py-1 rounded-xl font-normal text-[14px] text-textPrimaryColor placeholder:text-[14px] outline-none`}
              />
            </div>
            {/* {globalSearchQuery?.length > 0 && (
              <img
                src="/assets/close-icon.svg"
                alt="close-icon"
                className="cursor-pointer"
                onClick={() => setGlobalSearchQuery("")}
              />
            )} */}
            <div className="flex justify-center items-center mr-[0.5%] text-[15px] text-white w-[30%] bg-gradient-to-r from-[#1A67D8] to-[#0047AF] h-[48px] rounded-[48px] cursor-pointer" onClick={handleSearchClick}>
              Search
            </div>
            {globalSearchQuery?.length > 0 &&
              productsBySearchQuery?.length > 0 && (
                <div ref={scrollContainerRef} className="w-full h-[33vh] bg-whiteColor  border rounded-3xl shadow py-[3%] mt-1 absolute left-0 right-0 top-14 z-50 overflow-y-scroll scrollbar-hide">
                  {productsBySearchQuery?.map((item, index) => (
                    <div
                      className="w-full h-fit flex justify-between items-center border-b px-[2%] py-[1%] cursor-pointer"
                      key={index}
                      onClick={() => handleAddProductsToBeSearched(item)}
                    >
                      <span className="font-normal text-[0.8vw] text-textPrimaryColor">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              )}
          </div>
        </div>
        <div className="bg-[#D2D2D2] rounded-b-3xl px-[6%] py-[0.5%]">
          <p className="font-normal text-[0.8vw] text-textPrimaryColor">
            Get <b>Flat 20% OFF*</b> on orders above ₹799 | Use:
            <b>FINELABS20</b>
          </p>
        </div>
        <img
          src="/assets/finelabs-logo-light.svg"
          alt="finelabs-logo"
          className="w-[1%] absolute rotate-180 top-[4%] right-[1.5%]"
        />
      </div>

      {/** Small Screens */}
      <div className="w-full h-fit bg-whiteColor mt-[6%] flex flex-col justify-center items-center px-[3%] pb-[2%] lg:hidden relative">
        <div className="w-full h-fit bg-gradient-to-b from-[#2674E9] to-[#0E41A6] flex flex-col justify-end items-center rounded-3xl px-[3%] pt-[10%] pb-[7.5%]">
          <span className="font-semibold text-[6vw] text-whiteColor text-center">
            Your Health, Our
          </span>
          <span className="font-semibold text-[6vw] text-whiteColor text-center">
            Expertise – Accurate
          </span>
          <span className="font-semibold text-[6vw] text-whiteColor text-center">
            Tests From Leading
          </span>
          <span className="font-semibold text-[6vw] text-whiteColor text-center mb-[5%]">
            Brands
          </span>
          <p className="font-light text-[4vw] text-whiteColor text-center">
            Unlock accurate, fast, and
          </p>
          <p className="font-light text-[4vw] text-whiteColor text-center">
            affordable lab tests and radiology
          </p>
          <p className="font-light text-[4vw] text-whiteColor text-center">
            packages from trusted, leading
          </p>
          <p className="font-light text-[4vw] text-whiteColor text-center mb-[7.5%]">
            brands.
          </p>
          <div className="bg-whiteColor/75 flex justify-center items-center rounded-2xl p-[2%] space-x-1 mb-[7.5%]">
            {brandImages?.map((lab, index) => (
              <img
                src={lab.img}
                alt="brand-logo"
                key={index}
                loading="lazy"
                className="w-[65px] h-[65px] object-cover rounded-xl"
                onClick={() => navigate(lab.link)}
              />
            ))}
          </div>
          <div ref={(deviceOS === "android" || deviceOS === "ios") ? searchBarRef : null} className="w-[95%] lg:w-[33%] h-[56px] bg-whiteColor flex justify-between items-center rounded-[48px]  relative">
            <div className="flex w-full items-center ml-[2%]">
              {productsToBeSearched.length == 0 && (<IoIosSearch className="text-xl text-blue-300 mr-[2%]" />)}
              {productsToBeSearched.length > 0 && (
                <div ref={phoneScrollContainerRef} className="w-full h-11 ml-2 gap-y-2 gap-x-2 grid grid-cols-1 scrollbar-none pt-2 overflow-y-scroll mr-2">
                  {productsToBeSearched.map((product, index) => (
                    <div key={index} className="w-full px-2 h-[28px] rounded-[28px] bg-[#E0E0E0] flex justify-between items-center mr-2 text-[13px] text-[#57636C]">
                      <div className="w-fit truncate">
                        {product}
                      </div>
                      <img
                        src="/assets/close-icon.svg"
                        alt="close-icon"
                        className="cursor-pointer ml-1 flex-shrink-0"
                        onClick={() => handleRemoveProductsToBeSearched(product)}
                      />
                    </div>
                  ))}
                </div>
              )}
              <input
                type="text"
                value={globalSearchQuery}
                onChange={handleSearchQueryChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate("/search");
                  }
                }}
                placeholder="Search from 12,000+ Lab Tests, Packages, X-rays & Scans"
                className="w-[83%] h-full rounded-xl font-normal text-[14px] text-textPrimaryColor placeholder:text-[14px] outline-none"
              />
            </div>
            <div className="flex justify-center items-center mr-[1%] text-[15px] text-white w-[25%] bg-gradient-to-r from-[#1A67D8] to-[#0047AF] h-[48px] rounded-[48px]" onClick={handleSearchClick}>
              <img src="/assets/white-search-icon.svg" alt="" />
            </div>
            {globalSearchQuery?.length > 0 &&
              productsBySearchQuery?.length > 0 && (
                <div className="w-full h-[33vh] bg-whiteColor  border rounded-3xl shadow py-[3%] mt-1 absolute left-0 right-0 top-14 z-50 overflow-scroll scrollbar-hide">
                  {productsBySearchQuery?.map((item, index) => (
                    <div
                      className="w-full h-fit flex justify-between items-center border-b px-[2%] py-[1%] cursor-pointer"
                      key={index}
                      onClick={() => handleAddProductsToBeSearched(item)}
                    >
                      <span className="font-normal text-[14px] text-textPrimaryColor">
                        {item}
                      </span>
                    </div>
                  ))}
                </div>
              )}
          </div>
        </div>
        <div className="w-[90%] h-fit bg-[#D2D2D2] rounded-b-3xl py-[2%]">
          <p className="font-normal text-[3.5vw] text-textPrimaryColor text-center">
            Get <b>Flat 20% OFF*</b> on orders above ₹799 | Use:
            <b>FINELABS20</b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Searchbar;
